
import AttachCircle from "../../../assets/filled/AttachCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AttachCircleIcon({ className, dataTestid = "AttachCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AttachCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
